module.exports = __webpack_public_path__ + "img/II-44.1.69bbf533.svg";